const configMaps = {
    googleMapsApiKey: "AIzaSyB6vQ1WuRZ84ivRiNY5DWpyFBRrK3PCm7E",
};

export default configMaps;
